import Rectangle from '../../../../../../assets/icons/shapes/icons/square.svg?react';
import TShape from '../../../../../../assets/icons/shapes/icons/t-shape.svg?react';
import LShape from '../../../../../../assets/icons/shapes/icons/l-shape.svg?react';
import LShapeMirrored from '../../../../../../assets/icons/shapes/icons/l-shape-mirrored.svg?react';
import XShape from '../../../../../../assets/icons/shapes/icons/x-shape.svg?react';
import UShape from '../../../../../../assets/icons/shapes/icons/u-shape.svg?react';
import Atrium from '../../../../../../assets/icons/shapes/icons/atrium.svg?react';
import YShape from '../../../../../../assets/icons/shapes/icons/y-shape.svg?react';
import ZShape from '../../../../../../assets/icons/shapes/icons/z-shape.svg?react';
import ZShapeMirrored from '../../../../../../assets/icons/shapes/icons/z-shape-mirrored.svg?react';
import { BygningsForm } from '../../../../utils/registerEnums';

export const ShapeIcon = ({ shape }: { shape: BygningsForm }) => {
  switch (shape) {
    case BygningsForm.Rektangulaert:
      return <Rectangle />;
    case BygningsForm.TForm:
      return <TShape />;
    case BygningsForm.Atriumshus:
      return <Atrium />;
    case BygningsForm.YForm:
      return <YShape />;
    case BygningsForm.LForm:
      return <LShape />;
    case BygningsForm.UForm:
      return <UShape />;
    case BygningsForm.XForm:
      return <XShape />;
    case BygningsForm.ZForm:
      return <ZShape />;
    case BygningsForm.ZFormSpeilvendt:
      return <ZShapeMirrored />;
    case BygningsForm.LFormSpeilvendt:
      return <LShapeMirrored />;
  }
};
